// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { controlsContainerStyles } from "@steiner/Overrides/Widgets/ProductList/ProductListControlsContainer";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

controlsContainerStyles.container = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        flex-wrap: wrap;
        row-gap: 18px;
        padding-bottom: 12px;
        border-bottom: 1px solid ${color("common.border")};
        ${xScreen("lte", "md")} {
            flex-direction: column;
        }
    `,
};

controlsContainerStyles.leftColumn = {
    css: css`
        width: 100%;
        display: flex;
        align-items: center;
        max-width: 200px;
        & div[data-test-selector="productList_pagination"] {
            margin: 0 !important;
        }

        ${xScreen("lte", "md")} {
            max-width: unset;
            width: auto;
            flex-direction: column;
        }
    `,
};

controlsContainerStyles.rightColumn = {
    css: css`
        width: 100%;
        flex: 1;
        display: grid;
        grid-template-areas: "sort perPage view results";
        justify-content: space-between;
        align-items: center;
        row-gap: 16px;

        & div[data-test-selector="productList_pagination"] {
            margin: 0 !important;
        }
        & > .sortBy {
            grid-area: sort;
        }
        & > .view {
            grid-area: view;
        }
        & > .perPage {
            grid-area: perPage;
        }
        & > .pagination-page-number {
            grid-area: results;
        }

        ${xScreen("lte", "md")} {
            justify-content: space-between;
            grid-template-areas:
                "sort perPage"
                "view results";
            & span[class^="PerPageSelect"] {
                width: 100%;
            }
        }
    `,
};
